import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Text } from 'components/common/Elements/Elements';

import { moneyFormater, isData } from 'utils/common';

import classes from './TableCoupon.module.scss';

const TableCoupon = ({ percent, amount }) => {
  const { t } = useTranslation(['activity']);

  if (isData(percent) && isData(amount)) {
    return (
      <div className={classes.discount}>
        <Text>{t('activity:customers.SAVE')}</Text>
        <Text>{`${percent}% and ${moneyFormater(amount)}`}</Text>
      </div>
    );
  }

  if (isData(percent)) {
    return `${t('activity:customers.SAVE')} - ${percent}%`;
  }

  if (isData(amount)) {
    return `${t('activity:customers.SAVE')} - ${moneyFormater(amount)}`;
  }

  return 'NA';
};

TableCoupon.propTypes = {
  percent: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default TableCoupon;
